import { DialogTitle as MUIDialogTitle, Divider } from "@mui/material";
import * as React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";

export const DialogTitle = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => (
    <React.Fragment>
        <MUIDialogTitle style={{ padding: "12px 20px 8px", ...style }}>{children}</MUIDialogTitle>
        <Divider />
    </React.Fragment>
);

export const FormattedDialogTitle = ({
    id,
    values,
    children,
}: {
    id: MessageDescriptor;
    values?: { [s: string]: any };
    children?: React.ReactNode;
}) => (
    <DialogTitle>
        <FormattedMessage {...id} values={values} />
        {children}
    </DialogTitle>
);
